<div>
  <mat-form-field
    appearance="outline"
    class="full-width"
    [class.disable]="disabled"
    [class.disable-background]="disableBackground"
    [ngClass]="{
      'mat-form-field-warning mat-form-field-outline-warning': showWarning,
      small: sizeSmall,
      regular: sizeRegular,
    }"
    [floatLabel]="extraOption ? 'always' : 'auto'"
  >
    <mat-label>
      {{ placeholder }}
    </mat-label>
    <mat-select
      [required]="required"
      [placeholder]="extraOption || ''"
      disableOptionCentering
      panelClass="multi-select-server-side-select-panel"
      [formControl]="multiServerSideCtrl"
      [multiple]="multiple"
      (openedChange)="panelChange($event)"
      #multiSelect
    >
      <mat-select-trigger>
        @if (showColorDot && multiple && multiServerSideCtrl.value?.length) {
          <span class="trigger-chips">
            <span class="tag-chip">
              <span
                class="tag-chip-dot"
                [style.background-color]="
                  getColor(multiServerSideCtrl.value[0])
                "
              ></span>
              <span class="tag-chip-name">{{ triggerLabel() }}</span>
              <span
                class="tag-chip-remove"
                (click)="
                  removeTriggerChip(multiServerSideCtrl.value[0], $event)
                "
                >&#x2715;</span
              >
            </span>
            @if (multiServerSideCtrl.value.length > 1) {
              <span class="additional-selection">
                +{{ multiServerSideCtrl.value.length - 1 }}
              </span>
            }
          </span>
        } @else {
          {{ triggerLabel() }}
          @if (multiServerSideCtrl.value?.length > 1) {
            <span class="additional-selection">
              +{{ multiServerSideCtrl.value.length - 1 }}
            </span>
          }
        }
      </mat-select-trigger>
      <mat-option>
        <ngx-mat-select-search
          [disableScrollToActiveOnOptionsChanged]="true"
          [noEntriesFoundLabel]="noEntriesFoundLabel"
          [placeholderLabel]="placeholderLabel"
          [formControl]="multiServerSideFilteringCtrl"
          [clearSearchInput]="false"
        ></ngx-mat-select-search>
      </mat-option>
      @if (!multiple && !disableDefaultValue) {
        <mat-option [value]="undefined">-</mat-option>
      }
      @for (resource of filteredServerSideResources | async; track resource) {
        <mat-option [value]="resource">
          @if (showColorDot) {
            <span class="option-with-color-dot">
              <span
                class="option-color-dot"
                [style.background-color]="getColor(resource)"
              ></span>
              <span>{{ getName(resource) }}</span>
            </span>
          }
          @if (!showColorDot) {
            <app-training-name-with-state
              [text]="getName(resource)"
              [state]="resource.state"
            ></app-training-name-with-state>
          }
        </mat-option>
      }
    </mat-select>
  </mat-form-field>
</div>
